import httpClient from './_httpClient';
import httpClientWithoutToken from "./_httpClientWithoutToken";

const END_POINT = "/users/phone"

const sendVerificationCode = (phone, userId = null) => {
  let data = {phone: phone};
  if (userId) {
    data.id = userId;
  }
  return httpClient.post(END_POINT, data)
};
const sendVerificationCodeForSignUp = (phone, userId = null) => {
  let data = {phone: phone};
  if (userId) {
    data.id = userId;
  }
  return httpClientWithoutToken.post(END_POINT, data)
};
const updatePhone = (phone, code, userId = null) => {
  let data = {phone: phone, code: code};
  if (userId) {
    data.id = userId;
  }
  return httpClient.put(END_POINT, data)
};
const updatePhoneWithoutVerification = (phone,  userId = null) => {
  let data = {phone: phone};
  if (userId) {
    data.id = userId;
  }
  return httpClient.put(`${END_POINT}-without-verification`, data)
};
const updatePhoneForSignUp = (phone, code, userId = null) => {
  let data = {phone: phone, code: code};
  if (userId) {
    data.id = userId;
  }
  return httpClientWithoutToken.put(END_POINT, data)
};

export {
  sendVerificationCode,
  updatePhone,
  sendVerificationCodeForSignUp,
  updatePhoneForSignUp,
  updatePhoneWithoutVerification
}
